import React, { useState, useEffect } from 'react';
import {TextField, Button, Box, Container, Typography} from "@mui/material";
import { useNavigate} from 'react-router-dom';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
const host = window?.location?.hostname ?? 'localhost'
const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [emailErr, setEmailErr] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordErr, setPasswordErr] = useState(false);
    const [message, setMessage] = useState('');
    const [ws, setWs] = useState(null);
    const [input, setInput] = useState('');
    const [serverMessage, setServerMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const sendMessage = () => {
        if (ws && input.trim()) {
            ws.zsend(input);
            setInput('');
        }
    };
    const handleLogin = async () => {
        if(email === ''){
            setEmailErr(true)
        }
        if(password === ''){
            setPasswordErr(true)
        }
        const response = await fetch(`https://${host}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });
        const data = await response.json();

        if (data.token) {
            localStorage.setItem('token', data.token);
            setIsLoggedIn(true);
            window.location.reload();
            setErrorMessage('');
        } else {
            setErrorMessage(data.message);
        }
    };

    const handleRegister = async () => {
        const response = await fetch(`https://${host}/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
        });
        const data = await response.json();

        if (data.message) {
            setErrorMessage(data.message);
        }
    };

    useEffect(() => {
        // Показать сообщение, если пользователь не подтвердил свою почту
        const token = localStorage.getItem('token');
        if (token) {
            // Подключение к WebSocket
            const socket = new WebSocket(`wss://${host}/ws`, token);
            socket.onopen = () => {
                console.log('Подключение установлено!');
            };
            socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.error) {
                    setErrorMessage(data.error);
                } else {
                    setServerMessage(data.message);
                }
            };
        }
    }, [isLoggedIn]);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    return (
        <Container sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "top",
                height: "100vh",
                //marginTop:"-230px"
            }} >
            <Box  sx={{
                    //marginTop: '50px',
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: 300,
                    height: "440px",
                    padding: 3,
                    boxShadow: 3,
                    textAlign: "center",
                }} >
                <Typography variant="h5" sx={{ textAlign: "center", mb: 2 }}>
                    Вход
                </Typography>
                <div style={{
                    position: 'fixed', marginTop: '32px',
                    marginLeft: '-28px',
                    width: '300px',
                    fontSize:'14px', color: '#e64034'}}>{errorMessage ? errorMessage : ''}</div>
                <br/>
                <TextField
                    label="Логин или Email"
                    error={emailErr}
                    helperText={emailErr ? "Придется ввести ^ туда, что просят!" : ''}
                    fullWidth
                    type="email"
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        setEmailErr(false)
                    }}
                />
                <TextField
                    error={passwordErr}
                    helperText={passwordErr ? "Придется ввести ^ туда, что просят!" : ''}
                    label="Пароль"
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                        setPasswordErr(false)
                    }}
                    slotProps={
                        {  input:
                                {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Показать пароль"
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }
                        }}
                />
                <Button variant="contained" color="primary" fullWidth onClick={handleLogin}>
                    Войти
                </Button>
                <Button variant="outlined" color="primary"   onClick={()=>{navigate("/EnterEmail")}} fullWidth>
                    Войти через почту
                </Button>
                <Button variant="outlined" color="primary" onClick={()=>{navigate("/RegistrationForm")}} fullWidth>
                    Зарегистрироваться
                </Button>
            </Box>
        </Container>
    );
};

export default LoginForm;
